// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__sXGnj","notes":"Notes_notes__1jMeb"};